import type { TokenPath } from '../tokens/generated/types'

export const legacyBadgeColors = [
  'pink',
  'steel',
  'mint',
  'dark-mint',
  'beige',
  'dark-beige',
  'indigo',
  'dark-indigo',
  'yellow',
  'red',
  'dark-red',
  'green',
  'purple',
  'dark-purple',
  'extra-dark-purple',
  'success',
  'error',
  'warning',
  'info',
  'stone'
] as const

export type LegacyBadgeColor = (typeof legacyBadgeColors)[number]

export const tokenBadgeColors = [
  'precis-blue',
  'cobalt',
  'teal',
  'magenta',
  'orange',
  'brown',
  'violet',
  'andesite',
  'graph-pink',
  'olive',
  'sienna',
  'graph-green',
  'caramel',
  'aqua',
  'salmon',
  'brass',
  'semantic-error',
  'semantic-warning',
  'semantic-success',
  'semantic-info',
  'neutral'
] as const

export type TokenBadgeColor = (typeof tokenBadgeColors)[number]

export const comparisonBadgeColors = ['comparison-positive', 'comparison-negative', 'comparison-neutral'] as const

export type ComparisonBadgeColor = (typeof comparisonBadgeColors)[number]

export const badgeColors = [...legacyBadgeColors, ...tokenBadgeColors, ...comparisonBadgeColors] as const

export type NamedColor = (typeof badgeColors)[number]

export type NamedColorBorderVariant = 'lighter' | 'darker'

export interface NamedColorDefinition {
  fill: TokenPath
  border?: {
    lighter: TokenPath
    darker: TokenPath
  }
}

export const legacyBadgeColorMigrationMap = new Map<LegacyBadgeColor, TokenBadgeColor>([
  ['pink', 'graph-pink'],
  ['steel', 'neutral'],
  ['mint', 'graph-green'],
  ['dark-mint', 'teal'],
  ['beige', 'caramel'],
  ['dark-beige', 'caramel'],
  ['indigo', 'cobalt'],
  ['dark-indigo', 'violet'],
  ['yellow', 'brass'],
  ['red', 'salmon'],
  ['dark-red', 'orange'],
  ['green', 'graph-green'],
  ['purple', 'violet'],
  ['dark-purple', 'andesite'],
  ['extra-dark-purple', 'andesite'],
  ['success', 'semantic-success'],
  ['error', 'semantic-error'],
  ['warning', 'semantic-warning'],
  ['info', 'semantic-info'],
  ['stone', 'neutral']
])
